import React from "react";
import "./SearchBar.css";
import { FiSearch } from "react-icons/fi";

const SearchBar = ({ searchValue, setSearchValue }) => {
  return (
    <div className="premium-search-container">
      <div className="premium-search-inner">
        <FiSearch className="premium-search-icon" />
        <input
          type="text"
          className="premium-search-input"
          placeholder="What are you craving?"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchBar;
